//import {HOST} from '../api/fileApi.js'
const src = path => {
    if(!path){
        return path
    }
	 
    if(path.slice(0, 4) == 'http'){
		
        return path
    } else {
		//return "http://test.inspectors.cloud"+path;
        //return "https://www.inspector.ltd"+path
        return (location.protocol=='http:'?process.env.VUE_APP_BASE_API:process.env.VUE_APP_BASES_API)+path

    }
}
const chat = path => {
    if(!path){
        return path
    }
    if(path.slice(0, 4) == 'http'){
        return path
    } else {
		//return "http://test.inspectors.cloud"+path;
		//console.log(location,"===location====");
		return location.origin+path;
        //return "http://www.f-qc.com"+path

    }
}
const playMessageAudio = () => {
     // @todo Uncaught (in promise) DOMException: play() failed because the user didn't interact with the document first.
     let audio = new Audio(require('../assets/new_message.mp3'));
     audio.play();
 }
 
module.exports = {
    src,
	chat,
	playMessageAudio
}
